import { useTranslation } from '@mukil/i18n';
import { approval_line } from './pay_run_complete_view_logic';
import { format_date } from '../../lib/format';

/**
 * The one "Approved by {name} on {date}" / "Approved on {date}" sentence,
 * shared by the completion view and the Approval step so the two never
 * drift. Renders nothing when the approval date is unknown.
 */
export function PayRunApprovedLine({
  approved_at,
  approver_name,
  className,
}: {
  approved_at: string | null | undefined;
  approver_name: string | undefined;
  className?: string;
}): React.JSX.Element | null {
  const { t, locale } = useTranslation('wp');
  const line = approval_line(approved_at, approver_name);
  if (line === undefined) return null;

  const date = format_date(line.approved_at, locale);
  return (
    <p className={className} data-testid="pay-run-approved-line">
      {line.kind === 'by_on'
        ? t('pay_run.approved_by_on', { name: line.name, date })
        : t('pay_run.approved_on', { date })}
    </p>
  );
}
